// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IErrorDto,
  IExchangeTokenRequestDto,
  IGenericErrorDto,
  ILinkTokenResponseDto,
  IUpdateAccountVerificationStatusDto,
} from '../models/index';
import {
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IExchangeTokenRequestDtoFromJSON,
    IExchangeTokenRequestDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    ILinkTokenResponseDtoFromJSON,
    ILinkTokenResponseDtoToJSON,
    IUpdateAccountVerificationStatusDtoFromJSON,
    IUpdateAccountVerificationStatusDtoToJSON,
} from '../models/index';

export interface CreateLinkTokenRequest {
    accountId?: number;
}

export interface ExchangeTokenRequest {
    iExchangeTokenRequestDto: IExchangeTokenRequestDto;
}

export interface UpdateVerificationStatusRequest {
    iUpdateAccountVerificationStatusDto: IUpdateAccountVerificationStatusDto;
}

/**
 * PlaidProxyApiServiceServiceApi - interface
 * 
 * @export
 * @interface PlaidProxyApiServiceServiceApiInterface
 */
export interface PlaidProxyApiServiceServiceApiInterface {
    /**
     * 
     * @summary Create plaid link token
     * @param {number} [accountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaidProxyApiServiceServiceApiInterface
     */
    createLinkTokenRaw(requestParameters: CreateLinkTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILinkTokenResponseDto>>;

    /**
     * Create plaid link token
     */
    createLinkToken(requestParameters: CreateLinkTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILinkTokenResponseDto>;

    /**
     * 
     * @summary Exchange public token to access token
     * @param {IExchangeTokenRequestDto} iExchangeTokenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaidProxyApiServiceServiceApiInterface
     */
    exchangeTokenRaw(requestParameters: ExchangeTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Exchange public token to access token
     */
    exchangeToken(requestParameters: ExchangeTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update account verification status
     * @param {IUpdateAccountVerificationStatusDto} iUpdateAccountVerificationStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaidProxyApiServiceServiceApiInterface
     */
    updateVerificationStatusRaw(requestParameters: UpdateVerificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update account verification status
     */
    updateVerificationStatus(requestParameters: UpdateVerificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class PlaidProxyApiServiceServiceApi extends runtime.BaseAPI implements PlaidProxyApiServiceServiceApiInterface {

    /**
     * Create plaid link token
     */
    async createLinkTokenRaw(requestParameters: CreateLinkTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILinkTokenResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plaid/link-token`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILinkTokenResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create plaid link token
     */
    async createLinkToken(requestParameters: CreateLinkTokenRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILinkTokenResponseDto> {
        const response = await this.createLinkTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exchange public token to access token
     */
    async exchangeTokenRaw(requestParameters: ExchangeTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iExchangeTokenRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iExchangeTokenRequestDto',
                'Required parameter "iExchangeTokenRequestDto" was null or undefined when calling exchangeToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plaid/exchange-token`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IExchangeTokenRequestDtoToJSON(requestParameters['iExchangeTokenRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Exchange public token to access token
     */
    async exchangeToken(requestParameters: ExchangeTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exchangeTokenRaw(requestParameters, initOverrides);
    }

    /**
     * Update account verification status
     */
    async updateVerificationStatusRaw(requestParameters: UpdateVerificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iUpdateAccountVerificationStatusDto'] == null) {
            throw new runtime.RequiredError(
                'iUpdateAccountVerificationStatusDto',
                'Required parameter "iUpdateAccountVerificationStatusDto" was null or undefined when calling updateVerificationStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/bank-accounts/verification-status`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IUpdateAccountVerificationStatusDtoToJSON(requestParameters['iUpdateAccountVerificationStatusDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update account verification status
     */
    async updateVerificationStatus(requestParameters: UpdateVerificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateVerificationStatusRaw(requestParameters, initOverrides);
    }

}
